import React, { CSSProperties, FC } from 'react';
import { CardWrapper } from 'components/Lane/Lane.css';
import { LoadingRectangle, TitlePlaceholder } from 'style/styled-components/reusable.css';
import { cardVariantCss } from './Card.css';
import { CardVariant, cardSpec } from './cardVariants';

type PropTypes = {
    variant: CardVariant;
    withTitle?: boolean;
    style?: CSSProperties;
};

export const CardLoading: FC<PropTypes> = ({ variant, withTitle = false, style }) => {
    const spec = cardSpec(variant);

    return (
        <CardWrapper className={spec.wrapperClassName} width={'auto'} height={'auto'} variantCss={cardVariantCss(spec)} style={style}>
            <LoadingRectangle />
            {withTitle && (
                <TitlePlaceholder>
                    <LoadingRectangle />
                </TitlePlaceholder>
            )}
        </CardWrapper>
    );
};
